import React from 'react';
import { useChat } from '@/hooks/useChat';
import ChatDropdown from '@/components/Dropdowns/ChatDropdown';
import CollectionChatItemView from './CollectionChatItemView';
import NativeCollectionChatItem from './NativeCollectionChatItem';

function CloudCollectionChatItem(props) {
  const { isPinned } = useChat(props.chat?.id);
  return <CollectionChatItemView {...props} isPinned={isPinned} renderDropdown={({ onOpenChange, TriggerComponent }) => (
    <ChatDropdown conversationId={props.chat?.id} withSelectMultipleChats={false}
      onOpenChange={onOpenChange} TriggerComponent={TriggerComponent} />
  )} />;
}
function CollectionChatItem(props) {
  return props.chat?.execution?.type === 'mac-opencode'
    ? <NativeCollectionChatItem {...props} /> : <CloudCollectionChatItem {...props} />;
}
export default React.memo(CollectionChatItem);
